export const NUDGE_PERSONA = {
  DIONYSUS: 'DIONYSUS',
  ARTEMIS: 'ARTEMIS',
  NIKE: 'NIKE',
  HEPHAESTUS: 'HEPHAESTUS',
};

export const VISIBILITY = {
  VISIBLE: 'VISIBLE',
  HIDDEN: 'HIDDEN',
};

export const DEMO_COMPANY_ID = 6;
export const FRONT_COMPANY_ID = 230;
export const ENTERPRISE_DEMO_COMPANY_ID = 774;
export const NOOM_COMPANY_ID = 938;
export const MONROE_CAPITAL_COMPANY_ID = 1783;
export const VISA_COMPANY_ID = 2230;
export const CS_DEMO_COMPANY_ID = 2429;
export const VISA_SANDBOX_COMPANY_ID = 3385;

export const HARASSMENT_PREVENTION_COURSE_ID = 1;
export const ZOOM_COURSE_ID = 6;
export const ABAC_COURSE_ID = 12;
export const DIVERSITY_AND_INCLUSION_COURSE_ID = 15;
export const HIRING_AND_INTERVIEWING_COURSE_ID = 16;
export const CODE_OF_CONDUCT_COURSE_ID = 24;
export const IN_GOOD_COMPANY_COURSE_ID = 48;

export const ACCOUNTING_FINANCIAL_CONTROLS_CATEGORY_ID = 8;

export const NUDGE_RATINGS = {
  LIKE: 'LIKE',
  DISLIKE: 'DISLIKE',
};

export const NUDGE_INDUSTRY = {
  TECH: 'TECH',
  PROFESSIONAL_SERVICES: 'PROFESSIONAL_SERVICES',
};

export const COMMUNICATION_PREFERENCES = {
  EMAIL: 'EMAIL',
  SLACK: 'SLACK',
  ZOOM: 'ZOOM',
};

export const USER_ROLES = {
  MANAGER: 'MANAGER',
  NONMANAGER: 'NONMANAGER',
};

export const SLIDE_TYPES = {
  ARTICLE: 'ARTICLE',
  AUDIO: 'AUDIO',
  QUESTION: 'QUESTION',
  KNOWLEDGE_CHECK: 'KNOWLEDGE_CHECK',
};

export const END_SLIDE_TYPES = {
  SALES: 'sales',
  MARKETING: 'marketing',
  CS: 'cs',
  NONE: 'none',
};

export const TRAINING_CENTER_MODES = {
  TRAINING: 'TRAINING',
  ADMIN_PREVIEW: 'ADMIN_PREVIEW',
  REVIEWING_CONTENT: 'REVIEWING_CONTENT',
  SALES: 'SALES',
} as const;

export const MESSAGE_TYPE = {
  EMAIL: 'EMAIL',
  SLACK: 'SLACK',
  ZOOM: 'ZOOM',
};

// keep in order, DO NOT ALPHABETIZE
export const ONBOARDING_STEP = {
  CONFIRM_COMPANY_NAME: 'CONFIRM_COMPANY_NAME',
  UPLOAD_EMPLOYEES: 'UPLOAD_EMPLOYEES',
  ADD_A_COURSE: 'ADD_A_COURSE',
  ADD_POLICIES: 'ADD_POLICIES',
  INTRODUCE_ETHENA_TO_TEAM: 'INTRODUCE_ETHENA_TO_TEAM',
  ALLOWLIST_ETHENA_EMAIL: 'ALLOWLIST_ETHENA_EMAIL',
  SCHEDULE_ASSIGNMENT: 'SCHEDULE_ASSIGNMENT',

  // FREEMIUM SPECIFIC
  REVIEW_ASSIGNMENT: 'REVIEW_ASSIGNMENT',
  VIEW_UPSELL: 'VIEW_UPSELL',
};

export enum PageName {
  ADMIN_ANALYTICS = 'ADMIN_ANALYTICS',
  ADMIN_ASSIGNMENT = 'ADMIN_ASSIGNMENT',
  ADMIN_CASE_MANAGEMENT = 'ADMIN_CASE_MANAGEMENT',
  ADMIN_CASE_MANAGEMENT_UPSELL = 'ADMIN_CASE_MANAGEMENT_UPSELL',
  ADMIN_CONTENT_LIBRARY = 'ADMIN_CONTENT_LIBRARY',
  ADMIN_DASHBOARD = 'ADMIN_DASHBOARD',
  ADMIN_ETHENA_INVOICE_CONTENT_LIBRARY = 'ADMIN_ETHENA_INVOICE_CONTENT_LIBRARY',
  ADMIN_EVENTS = 'ADMIN_EVENTS',
  ADMIN_PHISHING = 'ADMIN_PHISHING',
  ADMIN_SETTINGS = 'ADMIN_SETTINGS',
  ADMIN_TEAM_INSIGHTS = 'ADMIN_TEAM_INSIGHTS',
  ADMIN_TEAM_MEMBERS = 'ADMIN_TEAM_MEMBERS',
  ADMIN_TRAINING_PREVIEW = 'ADMIN_TRAINING_PREVIEW',

  TRAINING_CENTER = 'TRAINING_CENTER',

  INTERNAL = 'INTERNAL',
  INTERNAL_COMPANIES = 'INTERNAL_COMPANIES',
  INTERNAL_COURSES = 'INTERNAL_COURSES',
  INTERNAL_PARTNERS = 'INTERNAL_PARTNERS',
  INTERNAL_PREVIEW_LINKS = 'INTERNAL_PREVIEW_LINKS',
  INTERNAL_QUESTIONS = 'INTERNAL_QUESTIONS',
  INTERNAL_SEARCH = 'INTERNAL_SEARCH',
  INTERNAL_STRING_VARIABLES = 'INTERNAL_STRING_VARIABLES',
  INTERNAL_TEMPLATES = 'INTERNAL_TEMPLATES',
  INTERNAL_THEMES = 'INTERNAL_THEMES',
  INTERNAL_USER_ROLES = 'INTERNAL_USER_ROLES',
  INTERNAL_VIDEO_LIBRARY = 'INTERNAL_VIDEO_LIBRARY',
}

export const COURSE_OFFER_TYPES = {
  OTS_LIVE: 'OTS_LIVE',
  OTS_DEVELOPMENT: 'OTS_DEVELOPMENT',
  ENTERPRISE_LIVE: 'ENTERPRISE_LIVE',
  ENTERPRISE_DEVELOPMENT: 'ENTERPRISE_DEVELOPMENT',
  SANDBOX: 'SANDBOX',
  IMPORTED_CUSTOM_COURSE: 'IMPORTED_CUSTOM_COURSE',
  OTS_FREE_LIVE: 'OTS_FREE_LIVE',
};

export const USER_STATUSES = {
  ACTIVE: 'ACTIVE',
  DISABLED: 'DISABLED',
  DELETED: 'DELETED',
  TERMINATED: 'TERMINATED',
};

export const ETHENA_QUESTIONS_EMAIL = 'questions@goethena.com';
export const ETHENA_SUPPORT_EMAIL = 'support@goethena.com';

export const BILLING_METHODS = {
  CREDIT_CARD: 'CREDIT_CARD',
  INVOICE: 'INVOICE',
  FREE: 'FREE',
} as const;

export const INIT_PARTNERSHIP_CONFIG_COOKIE = 'INITPARTNERCONFIG';

export const LOCATION_OVERRIDE = {
  NO_OVERRIDE: { label: 'No Override', value: 'NO_OVERRIDE' },
  FORCE_CA_FOR_US_LEARNERS: {
    label: 'Force location to CA for US learners',
    value: 'FORCE_CA_FOR_US_LEARNERS',
  },
  FORCE_CA_FOR_ALL_LEARNERS: {
    label: 'Force location to CA for ALL learners',
    value: 'FORCE_CA_FOR_ALL_LEARNERS',
  },
};

export const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const DEFAULT_CUSTOM_CATEGORY_LABEL = 'office';

export const FE_URL_PATHS = {
  ADMIN_EVENTS: '/events',
  ADMIN_EXPLORE_EVENTS: '/events/explore',
  ADMIN_INTEGRATIONS: '/settings/integrations',
  ADMIN_SETTINGS: '/settings',
  ADMIN_TRAINING_CAMPAIGNS: '/dashboard/training-campaigns',
  ADMIN_VANTA_SET_UP: '/settings/integrations/vanta-set-up',
  ADMIN_CASE_MANAGEMENT_SETTINGS: '/settings/new-case-management',
  ADMIN_CASE_MANAGEMENT_SETTINGS_CREATE_CATEGORY:
    '/settings/new-case-management/categories/create',
  ADMIN_COMPANY_POLICIES: '/settings/policies',
  HOTLINE: '/hotline',
  HOTLINE_WEB_FORM: '/hotline/web-form',
  LEARNING_CENTER: '/learning',
  LEARNING_CENTER_POLICIES: '/learning/policies',
  LEARNING_CENTER_POLICY_BOT: '/learning/policy-bot',
};

export const WORDS_PER_MINUTE_ESTIMATE = 240;
